import ApiConfig from '../api/config'
import axios from 'axios'
import { store } from '../store/store'
import router from '../router'
import * as actionTypes from '@/store/action-types'
import qs from 'qs'

axios.defaults.withCredentials = true;

const api = axios.create({
  baseURL: ApiConfig.basePath,
  withCredentials: true // Required for cookies to be sent/received
})

// separate axios instance for long-running AI operations (landing pages)
const aiApi = axios.create({
  baseURL: ApiConfig.basePath,
  timeout: 360000, // 6 minutes for AI generation
  withCredentials: true // Required for cookies to be sent/received
})

// Request interceptor for main api
api.interceptors.request.use((config) => {
  const token = JSON.parse(localStorage.getItem('token'))
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Request interceptor for AI api
aiApi.interceptors.request.use((config) => {
  const token = JSON.parse(localStorage.getItem('token'))
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Response interceptor for main api
const AUTH_ERROR_TYPES = ['token_expired', 'token_invalid', 'suspended_account']
api.interceptors.response.use(
  (response) => {
    const errorType = response.data?.meta?.error_type
    if (errorType && AUTH_ERROR_TYPES.includes(errorType)) {
      store.dispatch(actionTypes.LOGOUT_USER).then(() => {
        router.push({ name: 'login' })
      })
    }
    return response
  },
  (error) => {
    if (error.response?.data?.meta?.code == 401) {
      store.dispatch(actionTypes.LOGOUT_USER).then(() => {
        router.push({ name: 'login' })
      })
    }
    return Promise.reject(error)
  }
)

// Response interceptor for AI api
aiApi.interceptors.response.use(
  (response) => {
    const errorType = response.data?.meta?.error_type
    if (errorType && AUTH_ERROR_TYPES.includes(errorType)) {
      store.dispatch(actionTypes.LOGOUT_USER).then(() => {
        router.push({ name: 'login' })
      })
    }
    return response
  },
  (error) => {
    if (error.response?.data?.meta?.code == 401) {
      store.dispatch(actionTypes.LOGOUT_USER).then(() => {
        router.push({ name: 'login' })
      })
    }
    return Promise.reject(error)
  }
)

// Helper function to check if route is for AI landing pages
function isAiLandingPageRoute(url) {
  return url.includes('landing-pages') && (
    url === 'landing-pages' || 
    url.includes('/regenerate')
  )
}

// GET request function (unchanged)
export function getData(url, config = {}) {
  return api.get(url, config)
}

// POST request function with AI landing page detection
export function postData(url, data, config = {}) {
  if (isAiLandingPageRoute(url)) {
    return config?.emulateJSON
      ? encodeAndSendData('POST', url, data, true) // Pass true for AI api
      : aiApi.post(url, data, config)
  }
  
  // Use regular api for all other routes
  return config?.emulateJSON
    ? encodeAndSendData('POST', url, data)
    : api.post(url, data, config)
}

// PUT request function
export function putData(url, data, config = {}) {
  return config?.emulateJSON
    ? encodeAndSendData('PUT', url, data)
    : api.put(url, data, config)
}

// DELETE request function
export function deleteData(url, data = null, config = {}) {
  if (data) {
    return api.delete(url, { data, ...config })
  }
  return api.delete(url, config)
}

// Helper function with optional AI api support
function encodeAndSendData(method, url, data, useAiApi = false) {
  const apiInstance = useAiApi ? aiApi : api
  return apiInstance({
    method,
    url,
    data: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=utf-8',
    }
  })
}